import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { storableError } from '../../util/errors';
import { denormalisedResponseEntities } from '../../util/data';
import { currentUserShowSuccess } from '../../ducks/user.duck';
import { util as sdkUtil } from '../../util/sdkLoader';

import { PROFILE_REVIEWS } from '../../marketplace-custom-config';

// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { storableError } from '../../util/errors';
// import { setCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ProfileSettingsPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_ERROR';

export const GET_REVIEWS_REQUEST = 'app/ProfileSettingsPage/GET_REVIEWS_REQUEST';
export const GET_REVIEWS_SUCCESS = 'app/ProfileSettingsPage/GET_REVIEWS_SUCCESS';
export const GET_REVIEWS_ERROR = 'app/ProfileSettingsPage/GET_REVIEWS_ERROR';

// ================ Reducer ================ //

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,
  reviewsLoading: false,
  reviewsData: [],
  reviewsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR: {
      // eslint-disable-next-line no-console
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };
    }
    case GET_REVIEWS_REQUEST:
      return {
        ...state,
        reviewsError: null,
        reviewsLoading: true,
      };
    case GET_REVIEWS_SUCCESS:
      return {
        ...state,
        reviewsData: payload,
        reviewsLoading: false,
      };
    case GET_REVIEWS_ERROR:
      return {
        ...state,
        reviewsLoading: false,
        reviewsError: payload,
      };

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const getReviewsRequest = params => ({
  type: GET_REVIEWS_REQUEST,
});
export const getReviewsSuccess = reviewsData => ({
  type: GET_REVIEWS_SUCCESS,
  payload: reviewsData,
});
export const getReviewsError = error => ({
  type: GET_REVIEWS_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

// Images return imageId which we need to map with previously generated temporary id
export function uploadImage(actionPayload) {
  return (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    dispatch(uploadImageRequest(actionPayload));

    const bodyParams = {
      image: actionPayload.file,

      // // ================ Async Thunks ================ //

      // //////////////////
      // // Upload Image //
      // //////////////////
      // export const uploadImageThunk = createAsyncThunk(
      //   'ProfileSettingsPage/uploadImage',
      //   ({ id, file }, { rejectWithValue, extra: sdk }) => {
      //     const bodyParams = {
      //       image: file,
    };
    const queryParams = {
      expand: true,
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(resp => {
        const uploadedImage = resp.data.data;
        dispatch(uploadImageSuccess({ data: { id, uploadedImage } }));
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

export const updateProfile = actionPayload => {
  return (dispatch, getState, sdk) => {
    let currentUserResp;
    dispatch(updateProfileRequest());
    const queryParams = {
      expand: true,
      include: ['profileImage', 'stripeAccount', 'effectivePermissionSet'],
      'fields.image': [
        'variants.square-small',
        'variants.square-small2x',
        'variants.square-xsmall',
        'variants.square-xsmall2x',
      ],
      'imageVariant.square-xsmall': sdkUtil.objectQueryString({
        w: 40,
        h: 40,
        fit: 'crop',
      }),
      'imageVariant.square-xsmall2x': sdkUtil.objectQueryString({
        w: 80,
        h: 80,
        fit: 'crop',
      }),
    };
    // {
    //   expand: true,
    //   include: ['profileImage'],
    //   'fields.image': ['variants.square-small', 'variants.square-small2x'],
    // };

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams)
      .then(response => {
        currentUserResp = response;
        const getFavouritesUrl = `${apiBaseUrl()}/api/favourites/get`;
        return axios.get(getFavouritesUrl, { withCredentials: true });
      })
      .then(response => {
        currentUserResp.data.data.favourites = response.data;
      })
      .then(() => {
        dispatch(updateProfileSuccess(currentUserResp));
        const entities = denormalisedResponseEntities(currentUserResp);

        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }

        const currentUser = entities[0];
        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUser));
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

export const getProviderReviews = () => (dispatch, getState, sdk) => {
  dispatch(getReviewsRequest());
  return axios
    .get(`${apiBaseUrl()}/api/reviews/author`, { withCredentials: true })
    .then(res => {
      dispatch(getReviewsSuccess(res.data));
    })
    .catch(err => {
      console.error(err);
      dispatch(getReviewsError(err));
    });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  if (params?.tab === PROFILE_REVIEWS) {
    return dispatch(getProviderReviews());
  } else {
    return Promise.resolve();
  }
};
//         const entities = denormalisedResponseEntities(response);
//         if (entities.length !== 1) {
//           throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
//         }
//         const currentUser = entities[0];

//         // Update current user in state.user.currentUser through user.duck.js
//         dispatch(setCurrentUser(currentUser));
//         return response;
//       })
//       .catch(e => {
//         return rejectWithValue(storableError(e));
//       });
//   }
// );
// // Backward compatible wrapper for the updateProfile thunk
// export const updateProfile = actionPayload => dispatch => {
//   return dispatch(updateProfileThunk(actionPayload));
// };

// // ================ Slice ================ //

// const profileSettingsPageSlice = createSlice({
//   name: 'ProfileSettingsPage',
//   initialState: {
//     image: null,
//     uploadImageError: null,
//     uploadInProgress: false,
//     updateInProgress: false,
//     updateProfileError: null,
//   },
//   reducers: {
//     clearUpdatedForm: state => {
//       state.updateProfileError = null;
//       state.uploadImageError = null;
//     },
//   },
//   extraReducers: builder => {
//     builder
//       // uploadImage cases
//       .addCase(uploadImageThunk.pending, (state, action) => {
//         const { id, file } = action.meta.arg;
//         state.image = { id, file };
//         state.uploadInProgress = true;
//         state.uploadImageError = null;
//       })
//       .addCase(uploadImageThunk.fulfilled, (state, action) => {
//         const { id, uploadedImage } = action.payload;
//         const { file } = state.image || {};
//         state.image = { id, imageId: uploadedImage.id, file, uploadedImage };
//         state.uploadInProgress = false;
//       })
//       .addCase(uploadImageThunk.rejected, (state, action) => {
//         state.image = null;
//         state.uploadInProgress = false;
//         state.uploadImageError = action.payload.error;
//       })
//       // updateProfile cases
//       .addCase(updateProfileThunk.pending, state => {
//         state.updateInProgress = true;
//         state.updateProfileError = null;
//       })
//       .addCase(updateProfileThunk.fulfilled, state => {
//         state.image = null;
//         state.updateInProgress = false;
//       })
//       .addCase(updateProfileThunk.rejected, (state, action) => {
//         state.image = null;
//         state.updateInProgress = false;
//         state.updateProfileError = action.payload;
//       });
//   },
// });

// export const { clearUpdatedForm } = profileSettingsPageSlice.actions;
// export default profileSettingsPageSlice.reducer;
